<template>
  <div id="a1">
    <handicapGeneral
      v-if="!isExchange"
      :prod_code='code'
      :throttle="throttle"
    ></handicapGeneral>
    <handicapExchange
      v-else
      :prod_code='code'
      :throttle="throttle"
    ></handicapExchange>
  </div>
</template>

<script>
import handicapGeneral from './handicapGeneral.vue'
import handicapExchange from './handicapExchange.vue'
import { checkExchange } from '../../controller/util.js'
export default {
  name: 'handicap',
  components: {
    handicapGeneral,
    handicapExchange
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    throttle: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      isExchange: false
    }
  },
  created() {
    this.isExchange = checkExchange(this.code)
  },
}
</script>
